// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3E-QW","title":"Images90_title__2C7cI","images":"Images90_images__3TGT-"};